"use client";

import { OUTLOOK_WAITLIST_URL } from "@/constants";
import { useAuth } from "@/lib/auth/auth-provider";
import { trackGTMSignUp, useAppEvents } from "@jace/insights";
import { Icon } from "@jace/ui";
import { AuthError } from "./auth-error";

interface AuthButtonsProps {
	redirectUrl: string;
}

export function AuthButtons({ redirectUrl }: AuthButtonsProps) {
	const { signIn } = useAuth();
	const { emit } = useAppEvents();

	return (
		<>
			<AuthError />
			<button
				type="button"
				onClick={() => {
					emit({
						type: "continue_with_google_click",
					});
					if (redirectUrl.includes("/getting-started")) {
						trackGTMSignUp();
					}
					signIn(redirectUrl);
				}}
				className="w-full py-3 px-4 rounded-lg bg-white text-text-body-inverted font-medium flex items-center justify-center space-x-2 hover:opacity-90 transition-opacity"
			>
				<Icon kind="google" />
				<span>Continue with Google</span>
			</button>

			<div className="text-white/30 text-sm text-center">or</div>
			{/* <div className="relative">
				<span className="block w-full h-px bg-border" />
				<p className="inline-block w-fit text-sm bg-sidebar px-2 absolute -top-2 inset-x-0 mx-auto text-text-body-muted">
					or
				</p>
			</div> */}

			<a
				href={OUTLOOK_WAITLIST_URL}
				target="_blank"
				rel="noreferrer nofollow"
				className="w-full py-3 px-4 rounded-lg bg-white/10 backdrop-blur-lg text-white font-medium flex items-center justify-center space-x-2 hover:bg-white/20 transition-colors"
			>
				<Icon kind="outlook" className="fill-white" />
				<span>Join our Outlook waitlist</span>
			</a>
		</>
	);
}
